import { useEffect } from "react";

import { isEditableTarget, nextSecretWordProgress } from "../utils/secret-word";

/**
 * Calls `onMatch` each time `word` is typed on the page, outside any form
 * field. Listens only while `enabled`; pass a stable `onMatch`.
 */
const useSecretWord = (word: string, onMatch: () => void, enabled: boolean) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    let typed = "";

    const handleKeyDown = (event: KeyboardEvent) => {
      typed = isEditableTarget(event.target)
        ? ""
        : nextSecretWordProgress(typed, event, word);

      if (typed === word) {
        // Whatever onMatch opens may take focus before the browser inserts
        // the last letter, which would then land in it.
        event.preventDefault();
        typed = "";
        onMatch();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [word, onMatch, enabled]);
};

export default useSecretWord;
